(function () {
  if (window.KartmaxSearchAttribution) {
    return;
  }

  // KM search widget storage keys.
  var QUERY_ID_KEY = "km-search-widget:current-query-id";
  var QUERY_TEXT_KEY = "km-search-widget:current-query-text";
  var SESSION_ID_KEY = "km-search-widget:tracking-session-id";
  // Ids handed over in the /search URL (written by the search page JS).
  var CACHE_KEY = "kartmax:search-page-tracking";

  // Theme config nodes that hold the KartmaX API URLs.
  var SEARCH_CONFIG_SELECTOR = "[data-kartmax-km-search-config]";

  // KartmaX service path the events endpoint lives under.
  var SEARCH_SERVICE_PATH = "/search-get/v1/";
  var EVENTS_ENDPOINT = "events";

  var LOG_PREFIX = "[KartmaX events]";

  function getPageSearchQuery() {
    try {
      var query = new URL(window.location.href).searchParams.get("q");
      query = query && String(query).trim();
      return query && query !== "*" ? query : "";
    } catch (error) {
      return "";
    }
  }

  // Events are only sent when the page URL has ?q=.
  function isSearchAttributionActive() {
    return Boolean(getPageSearchQuery());
  }

  // Same normalisation as the search page JS (normalizeTrackingQuery).
  function normalizeQuery(value) {
    var text = String(value || "").trim().toLowerCase();
    return text === "*" ? "" : text;
  }

  function readStorageValue(storage, key) {
    try {
      return String(storage.getItem(key) || "").trim();
    } catch (error) {
      return "";
    }
  }

  // search_id is only used when it belongs to the current ?q=:
  //   1. ids handed over in the /search URL (sessionStorage), if the query matches
  //   2. ids written by the KM widget (localStorage), if its query text matches
  // session_id is session-wide and not tied to a query.
  function readSearchAttribution() {
    var query = getPageSearchQuery();
    var currentQuery = normalizeQuery(query);

    var cached = {};
    try {
      cached = JSON.parse(readStorageValue(window.sessionStorage, CACHE_KEY) || "{}") || {};
    } catch (error) {
      cached = {};
    }

    var cachedSearchId = String(cached.searchId || "").trim();
    var cachedSessionId = String(cached.sessionId || "").trim();
    var cachedMatchesQuery =
      Boolean(currentQuery) && normalizeQuery(cached.query) === currentQuery;

    var widgetSearchId = readStorageValue(window.localStorage, QUERY_ID_KEY);
    var widgetQueryText = readStorageValue(window.localStorage, QUERY_TEXT_KEY);
    var widgetSessionId = readStorageValue(window.localStorage, SESSION_ID_KEY);
    var widgetMatchesQuery =
      Boolean(currentQuery) && normalizeQuery(widgetQueryText) === currentQuery;

    var searchId =
      (cachedMatchesQuery && cachedSearchId) ||
      (widgetMatchesQuery && widgetSearchId) ||
      "";
    var sessionId = widgetSessionId || cachedSessionId || "";

    // Keep the query next to the cached id so the search page's own check works.
    if (searchId) {
      try {
        window.sessionStorage.setItem(
          CACHE_KEY,
          JSON.stringify({ searchId: searchId, sessionId: sessionId, query: query })
        );
      } catch (error) {
        // ignore
      }
    }

    return {
      query: query,
      searchId: searchId || null,
      sessionId: sessionId || null,
    };
  }

  function getKmWidget() {
    return window.__kartmaxKmSearchWidget || null;
  }

  function appendUrlQueryParam(urlString, paramName, paramValue) {
    if (!urlString || !paramName || !paramValue) {
      return urlString;
    }

    try {
      var url = new URL(urlString, window.location.origin);
      url.searchParams.set(paramName, paramValue);
      if (/^https?:\/\//i.test(urlString)) {
        return url.toString();
      }
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return urlString;
    }
  }

  // Removes empty values so an event only carries known fields.
  function compact(object) {
    var result = {};
    Object.keys(object).forEach(function (key) {
      var value = object[key];
      if (value === undefined || value === null || value === "") {
        return;
      }
      result[key] = value;
    });
    return result;
  }

  // ---------------------------------------------------------------------------
  // Events endpoint — not hardcoded. Expected shape:
  //   https://engine.kartmax.in/api/fast/{apiKey}/{collectionId}/search-get/v1/events
  //
  // Resolution order:
  //   1. window.KARTMAX_EVENTS_URL (manual override)
  //   2. config.eventsApiUrl from the theme's KM search config (explicit URL)
  //   3. Derived from config.searchApiUrl / config.apiUrl: the part before
  //      "/search-get/v1/" is kept as the base. If config.collectionId is set and
  //      the base does not already end with it, the collection id is appended.
  //
  // Returns "" when nothing can be resolved; the KM widget is then used instead.
  // An empty result is not cached, so a config node rendered later is still
  // picked up on the next event.
  // ---------------------------------------------------------------------------
  var cachedEventsUrl = "";

  function readSearchConfigs() {
    var configs = [];
    document.querySelectorAll(SEARCH_CONFIG_SELECTOR).forEach(function (node) {
      try {
        configs.push(JSON.parse(node.textContent || "{}") || {});
      } catch (error) {
        // ignore invalid config
      }
    });
    return configs;
  }

  function buildEventsUrlFromConfig(config) {
    if (!config || typeof config !== "object") {
      return "";
    }

    // Explicit events URL from the app config wins.
    if (typeof config.eventsApiUrl === "string" && config.eventsApiUrl.trim()) {
      return config.eventsApiUrl.trim();
    }

    var apiUrl = config.searchApiUrl || config.apiUrl;
    if (typeof apiUrl !== "string" || !apiUrl.trim()) {
      return "";
    }

    var collectionId = String(config.collectionId || "").trim();

    try {
      var url = new URL(apiUrl.trim(), window.location.origin);
      var index = url.pathname.indexOf(SEARCH_SERVICE_PATH);
      if (index === -1) {
        return "";
      }

      // "/api/fast/{apiKey}" or "/api/fast/{apiKey}/{collectionId}"
      var base = url.pathname.slice(0, index).replace(/\/+$/, "");
      var lastSegment = decodeURIComponent(base.split("/").pop() || "");

      if (collectionId && lastSegment !== collectionId) {
        base += "/" + encodeURIComponent(collectionId);
      }

      url.pathname = base + SEARCH_SERVICE_PATH + EVENTS_ENDPOINT;
      url.search = "";
      url.hash = "";
      return url.toString();
    } catch (error) {
      return "";
    }
  }

  function resolveEventsUrl() {
    if (cachedEventsUrl) {
      return cachedEventsUrl;
    }

    if (typeof window.KARTMAX_EVENTS_URL === "string" && window.KARTMAX_EVENTS_URL.trim()) {
      cachedEventsUrl = window.KARTMAX_EVENTS_URL.trim();
      return cachedEventsUrl;
    }

    var configs = readSearchConfigs();
    for (var i = 0; i < configs.length; i += 1) {
      var eventsUrl = buildEventsUrlFromConfig(configs[i]);
      if (eventsUrl) {
        cachedEventsUrl = eventsUrl;
        break;
      }
    }

    if (cachedEventsUrl) {
      console.log(LOG_PREFIX, "events URL:", cachedEventsUrl);
    }

    return cachedEventsUrl;
  }

  // Fallback: hand the event to the KM widget. Its methods take ONE argument.
  function sendViaKmWidget(eventName, body) {
    var widget = getKmWidget();
    if (!widget) {
      console.warn(LOG_PREFIX, eventName, "not sent: no events URL and no KM widget.");
      return Promise.resolve();
    }

    try {
      if (eventName === "add_to_cart" && typeof widget.trackAddToCart === "function") {
        return Promise.resolve(widget.trackAddToCart(body.data));
      }
      if (typeof widget.trackEvent === "function") {
        return Promise.resolve(widget.trackEvent(body));
      }
    } catch (error) {
      console.error(LOG_PREFIX, eventName, "KM widget error:", error);
      return Promise.resolve();
    }

    console.warn(LOG_PREFIX, eventName, "not sent: KM widget has no tracking method.");
    return Promise.resolve();
  }

  // Sends one event in the documented KartmaX shape:
  //   { event, session_id, data: { … } }
  // event_type is included as well — the endpoint rejects requests without it.
  // keepalive lets product_click finish while the product page opens.
  function sendKartmaxEvent(eventName, data) {
    var body = {
      event: eventName,
      event_type: eventName,
      session_id: data.session_id,
      data: data,
    };

    var eventsUrl = resolveEventsUrl();
    if (!eventsUrl || typeof window.fetch !== "function") {
      return sendViaKmWidget(eventName, body);
    }

    return window
      .fetch(eventsUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
        keepalive: true,
      })
      .then(function (response) {
        return response.text().then(function (text) {
          var result = text;
          try {
            result = JSON.parse(text);
          } catch (error) {
            // non-JSON reply
          }
          if (!response.ok || (result && result.success === false)) {
            console.warn(LOG_PREFIX, eventName, "rejected:", response.status, result, body);
          } else {
            console.log(LOG_PREFIX, eventName, "sent.", body);
          }
          return result;
        });
      })
      .catch(function (error) {
        // Network/CORS failure — let the KM widget try instead.
        console.warn(LOG_PREFIX, eventName, "direct send failed, using KM widget:", error);
        return sendViaKmWidget(eventName, body);
      });
  }

  function resolveCardTrackingData(card) {
    if (!card) {
      return null;
    }

    var wishlistNode = card.querySelector("[data-kartmax-wishlist]");
    var wishlistProductId = wishlistNode
      ? (wishlistNode.getAttribute("data-wlh-id") || "").trim()
      : "";

    var button = card.querySelector("[data-kartmax-add-to-cart]");

    // KartmaX id on the card first; Wishlist Hero's Shopify id is only a
    // fallback until the plp response returns KartmaX ids.
    var productId =
      (card.getAttribute("data-kartmax-product-id") || "").trim() ||
      (button ? (button.getAttribute("data-kartmax-variant-id") || "").trim() : "") ||
      wishlistProductId;

    var groupId =
      (card.getAttribute("data-kartmax-group-id") || "").trim() ||
      (button ? (button.getAttribute("data-kartmax-group-id") || "").trim() : "");

    var position = Number(card.getAttribute("data-kartmax-position") || "");
    var sku = button ? (button.getAttribute("data-kartmax-sku") || "").trim() : "";
    var price = parseFloat(button ? button.getAttribute("data-kartmax-price") : "");

    return {
      productId: productId,
      groupId: groupId,
      position: Number.isFinite(position) && position > 0 ? position : null,
      sku: sku,
      price: Number.isFinite(price) ? price : 0,
    };
  }

  // product_click data:
  // { query, group_id, sku, product_id (string), position, session_id, search_id }
  function trackProductClick(details) {
    if (!isSearchAttributionActive()) {
      return Promise.resolve();
    }

    var attribution = readSearchAttribution();
    var input = details || {};

    if (!input.product_id) {
      console.warn(LOG_PREFIX, "product_click skipped: product_id missing.", input);
      return Promise.resolve();
    }
    if (!attribution.sessionId) {
      console.warn(LOG_PREFIX, "product_click skipped: session_id missing.");
      return Promise.resolve();
    }

    return sendKartmaxEvent(
      "product_click",
      compact({
        query: attribution.query,
        group_id: input.group_id,
        sku: input.sku,
        product_id: String(input.product_id),
        position: input.position,
        session_id: attribution.sessionId,
        search_id: attribution.searchId,
      })
    );
  }

  // add_to_cart data:
  // { product_id (number), quantity, price, sku, group_id, session_id, search_id, query }
  function trackAddToCart(details) {
    if (!isSearchAttributionActive()) {
      return Promise.resolve();
    }

    var attribution = readSearchAttribution();
    var input = details || {};

    if (!input.product_id) {
      console.warn(LOG_PREFIX, "add_to_cart skipped: product_id missing.", input);
      return Promise.resolve();
    }
    if (!attribution.sessionId) {
      console.warn(LOG_PREFIX, "add_to_cart skipped: session_id missing.");
      return Promise.resolve();
    }

    var numericId = Number(input.product_id);
    var price = parseFloat(input.price);

    return sendKartmaxEvent(
      "add_to_cart",
      compact({
        product_id: Number.isFinite(numericId) ? numericId : String(input.product_id),
        quantity: Number(input.quantity) || 1,
        price: Number.isFinite(price) ? price : 0,
        sku: input.sku,
        group_id: input.group_id,
        session_id: attribution.sessionId,
        search_id: attribution.searchId,
        query: attribution.query,
      })
    );
  }

  // Binds product_click (image, title, View button) and add_to_cart (quick-add
  // button) tracking to a product grid. Listeners use the capture phase, so a
  // cart or theme handler calling stopPropagation() cannot block them.
  function bindProductGridTracking(root, options) {
    if (!root || !isSearchAttributionActive()) {
      return;
    }

    var settings = options || {};
    var cardSelector = settings.cardSelector || ".product-card";
    var clickSelector =
      settings.clickSelector ||
      ".product-card__image-link, .product-card__title, .product-card__cta";

    if (root.dataset.kartmaxProductClickBound !== "true") {
      root.dataset.kartmaxProductClickBound = "true";

      root.addEventListener(
        "click",
        function (event) {
          if (!isSearchAttributionActive() || !(event.target instanceof Element)) {
            return;
          }

          var link = event.target.closest(clickSelector);
          if (!link || !root.contains(link)) {
            return;
          }

          var data = resolveCardTrackingData(link.closest(cardSelector));
          if (!data || !data.productId) {
            console.warn(LOG_PREFIX, "product_click skipped: no product id on card.");
            return;
          }

          trackProductClick({
            product_id: data.productId,
            group_id: data.groupId,
            sku: data.sku,
            position: data.position,
          });
        },
        true
      );
    }

    if (root.dataset.kartmaxAddToCartTrackingBound !== "true") {
      root.dataset.kartmaxAddToCartTrackingBound = "true";

      root.addEventListener(
        "click",
        function (event) {
          if (!isSearchAttributionActive() || !(event.target instanceof Element)) {
            return;
          }

          var button = event.target.closest("[data-kartmax-add-to-cart]");
          if (!button || !root.contains(button)) {
            return;
          }

          var data = resolveCardTrackingData(button.closest(cardSelector));
          if (!data || !data.productId) {
            console.warn(LOG_PREFIX, "add_to_cart skipped: no product id on card.");
            return;
          }

          trackAddToCart({
            product_id: data.productId,
            quantity: 1,
            price: data.price,
            sku: data.sku,
            group_id: data.groupId,
          });
        },
        true
      );
    }
  }

  window.KartmaxSearchAttribution = {
    appendUrlQueryParam: appendUrlQueryParam,
    bindProductGridTracking: bindProductGridTracking,
    // Previous name, kept so any other script calling it keeps working.
    bindSearchGridTracking: bindProductGridTracking,
    getPageSearchQuery: getPageSearchQuery,
    isSearchAttributionActive: isSearchAttributionActive,
    readSearchAttribution: readSearchAttribution,
    resolveEventsUrl: resolveEventsUrl,
    sendKartmaxEvent: sendKartmaxEvent,
    trackAddToCart: trackAddToCart,
    trackProductClick: trackProductClick,
  };
})();